import React from 'react'
import { useIntl } from 'react-intl'
import { useTimer } from 'react-timer-hook'
import { Box } from '@mui/material'
import { capitalize } from '../../../../../utils/functions'
import {
    discountTimer,
    flexBetween,
    textCenter,
    time,
    timeTitle,
    timerContainer,
} from '../style'

interface Props {
    endTime: Date
    discount: number
    onExpire?: () => void
}

const DiscountTimer: React.FC<Props> = ({ endTime, discount, onExpire }) => {
    const { formatMessage } = useIntl()
    const expiryTimestamp = new Date()
    const timeDifferenceMs =
        new Date(endTime).getTime() - expiryTimestamp.getTime()
    const timeDifferenceSecs = Math.floor(timeDifferenceMs / 1000)

    expiryTimestamp.setSeconds(
        expiryTimestamp.getSeconds() + timeDifferenceSecs,
    )
    const { seconds, minutes, hours, days } = useTimer({
        expiryTimestamp,
        onExpire,
    })

    return (
        <Box sx={timerContainer}>
            {discount > 0 && <Box sx={discountTimer}>-{discount}%</Box>}

            <Box mb={1}>{formatMessage({ id: 'price' })}</Box>

            <Box sx={{ ...flexBetween, ...textCenter }}>
                <Box>
                    <Box sx={time}>{days}</Box>
                    <Box sx={timeTitle}>
                        {capitalize(formatMessage({ id: 'day' }))}
                    </Box>
                </Box>
                <Box>:</Box>

                <Box>
                    <Box sx={time}>{hours}</Box>
                    <Box sx={timeTitle}>
                        {capitalize(formatMessage({ id: 'hours' }))}
                    </Box>
                </Box>
                <Box>:</Box>

                <Box>
                    <Box sx={time}>{minutes}</Box>
                    <Box sx={timeTitle}>
                        {capitalize(formatMessage({ id: 'minutes' }))}
                    </Box>
                </Box>
                <Box>:</Box>

                <Box>
                    <Box sx={time}>{seconds}</Box>
                    <Box sx={timeTitle}>
                        {capitalize(formatMessage({ id: 'second' }))}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default DiscountTimer
